/**
 * PriceInput.tsx - 价格输入组件
 *
 * 功能说明：
 * - 单价输入框
 * - 自动关联价格配置提示
 *
 * 依赖关系：
 * - 依赖 antd InputNumber
 *
 * 关键注释索引：
 * - [价格格式化] - 见下方 formatter 配置
 *
 * 创建日期：2026-05-03
 * 作者：AI Assistant
 */

import React from 'react';
import { InputNumber } from 'antd';

interface PriceInputProps {
  value?: number;
  onChange?: (value: number | undefined) => void;
  disabled?: boolean;
  priceConfig?: {
    price: number;
    unit: string;
  } | null;
}

/**
 * [价格输入] 单价输入组件
 *
 * @description 支持：
 * - 货币格式化显示
 * - 价格配置关联提示
 * - 正数输入限制
 */
const PriceInput: React.FC<PriceInputProps> = ({
  value,
  onChange,
  disabled = false,
  priceConfig,
}) => {
  return (
    <InputNumber
      style={{ width: '100%' }}
      placeholder="请输入单价（可选）"
      min={0}
      step={0.001}
      precision={3}
      value={value}
      onChange={onChange}
      disabled={disabled}
      formatter={(val) => `¥ ${val}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
      parser={(val) => val!.replace(/¥\s?|(,*)/g, '') as any}
    />
  );
};

export default PriceInput;
